import {NewsletterSection_Content} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/order_success_page/v1/sections.types';
import {useShowToast} from '@aboutyou/ui-components';
import {FC, useEffect} from 'react';
import {NewsletterSubscriptionResponseType} from '../hooks/useNewsletterFormHandler';

export const FormNotificationMessage: FC<{
  newsletterUserProcessState: NewsletterSection_Content['type'];
  newsletterSubscriptionResponse?: NewsletterSubscriptionResponseType;
}> = ({newsletterUserProcessState, newsletterSubscriptionResponse}) => {
  const showToast = useShowToast();

  useEffect(() => {
    if (newsletterSubscriptionResponse) {
      showToast({
        type:
          newsletterSubscriptionResponse.type === 'success'
            ? 'SUCCESS'
            : 'ERROR',
        content: newsletterSubscriptionResponse.text,
        'data-testid':
          newsletterSubscriptionResponse.type === 'success'
            ? 'success'
            : 'error',
      });
    }
  }, [newsletterSubscriptionResponse]);

  useEffect(() => {
    if (newsletterUserProcessState?.$case === 'pending') {
      showToast({
        type: 'SUCCESS',
        content: newsletterUserProcessState.pending.confirmText,
        'data-testid': 'success',
      });
    }

    if (newsletterUserProcessState?.$case === 'subscribed') {
      showToast({
        type: 'SUCCESS',
        content: newsletterUserProcessState.subscribed.text,
        'data-testid': 'success',
      });
    }
  }, [newsletterUserProcessState]);

  return null;
};
